/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useState, useContext } from 'react';
import {
  CpdsInputFieldsWrapper,
  CpdsLabelWrapper,
  CpdsLabel,
  CpdsTextFieldWrapper,
  CpdsTextField,
  CpdsHelperTextWrapper,
  CpdsHelperLabel,
  CpdsInputCta,
  CpdsSubmitWrapper,
} from '../styles/cpds-input-fields-style';
import { CpdsSearchFieldsProps } from '../typings';
import { Cpds } from '@Cpds.Ui';
import styled, { ThemeContext } from 'styled-components';

const Search: React.FC<CpdsSearchFieldsProps> = ({
  domRef,
  exClasses = '',
  styleOverrides = {},
  
  inputWidth,
  SearchIcon = 'search',
  SearchIconSize = { width: '20', height: '20' },
  PlaceholderCopy = 'Enter Text',
  isError = false,
  ErrorIcon = 'information',
  ErrorIconSize = { width: '20', height: '20' },
  ErrorMessage = '',
  isOverRideTypography = false,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const themeContext: any = useContext(ThemeContext);
  const tokens = themeContext?.styles?.cpds;

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);



  return (
    <CpdsInputFieldsWrapper
      className={`cpds-input-fields ${exClasses} ${isError ? 'invalid' : ''}`}
      ref={domRef}
      style={styleOverrides}
      inputWidth={inputWidth}
    >

      <CpdsTextFieldWrapper className="text-field-wrapper search">
        <Cpds.Icon
          id="ico-1"
          name={SearchIcon}
          customSize={SearchIconSize}
          color={'#0C0E1C'}
        />
        <CpdsTextField
          type="text"
          placeholder={PlaceholderCopy}
          aria-label={PlaceholderCopy}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
      </CpdsTextFieldWrapper>
      {(isError && ErrorMessage) && (
        <CpdsHelperTextWrapper >
          {(ErrorIcon) && (
            <Cpds.Icon id="ico-3" color={tokens?.input_fields_error_label_color} name={ErrorIcon} customSize={ErrorIconSize} />
          )}
          <CpdsHelperLabel isError={isError} isOverRideTypography={isOverRideTypography}>{ErrorMessage}</CpdsHelperLabel>
        </CpdsHelperTextWrapper>
      )}

    </CpdsInputFieldsWrapper>
  );
};

export default Search;